import { PiHeartFill, PiHeartLight, PiUser } from 'react-icons/pi';
import { IconButton } from '../ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { useTranslation } from 'react-i18next';
import { signIn } from 'next-auth/react';

interface TooltipFavoritesUnloggedProps {
  toggleFavoritesView: () => void;
  areFavoritesShown: boolean;
  isUserLoggedIn: string | undefined;
}

const TooltipFavoritesUnlogged = ({
toggleFavoritesView,
areFavoritesShown,
isUserLoggedIn
}: TooltipFavoritesUnloggedProps) => {
  const { t } = useTranslation();
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <IconButton 
          noHover 
          className='hover:text-accent-blue'
          onClick={() => {
            if (isUserLoggedIn) toggleFavoritesView();
            else signIn('keycloak');
          }}
          data-testid='favorites-menu'
        >
          {areFavoritesShown ? (
              <PiHeartFill size={28} color='#0c8ce9' />
          ) : (
              <PiHeartLight size={28} />
          )}
        </IconButton>
      </TooltipTrigger>
      {!isUserLoggedIn && <TooltipContent className='w-58' sideOffset={8} side='right'>
        <div className='w-full m-2'>
          <p className='text-sm'>
            <span className='inline-flex align-middle mr-1'>
              <PiUser size={20} className='fill-accent-blue' />
            </span>
            {t('tooltip.favorites.notLoggedIn')}
          </p>
        </div>
      </TooltipContent>}
    </Tooltip>
  );
};

export default TooltipFavoritesUnlogged;
